import { createContext, useContext } from "react";
import type { AxiosInstance } from "axios";

export const ApiContext = createContext<AxiosInstance | null>(null);

export function useApi(): AxiosInstance {
  const instance = useContext(ApiContext);
  if (!instance) {
    throw new Error("useApi must be used within an ApiProvider");
  }
  return instance;
}
